var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattleRifleVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.804 20.85L106.822 20.907L105.977 19.95L89.7038 20.007L87.9578 21.5835L75.5123 21.4215L74.5838 21.1695L71.9723 16.8525L70.6988 16.233L72.5288 15.051V13.6425L71.0078 12.798L66.3908 12.63H64.3628L61.8293 12.5175L61.6523 11.5605H59.5193V12.687L55.9718 12.3495H50.5658V15.5175L58.2248 15.672V16.848L45.2723 16.854C45.2723 16.854 40.6268 16.7415 37.1048 17.8245C33.5828 18.9075 31.4198 23.1615 31.4198 23.1615H3.03833V25.2555L22.2548 25.3155V26.625H18.3263L18.4103 27.948H30.0098L29.2208 30.2565L30.0098 31.9125L31.9808 34.5915L32.9948 33.4095L35.9993 34.0395L41.3858 34.7355L49.6928 35.0055L54.8438 35.0985L62.2763 31.4385L62.3888 30.7065L68.4278 30.819L68.6963 33.579L70.2728 34.9305L74.7773 34.9875L78.2123 43.209L82.6283 41.829L82.9343 41.013L79.8458 32.8485L81.0848 30.9345H84.5198L86.0963 29.4705L88.5383 30.0045L89.1233 31.272L89.1938 36.2835L93.1913 40.281L94.0928 40.224L94.8818 41.013H108.706L109.691 40.4505L109.861 39.549L113.408 37.4085H117.52V21.4155L113.803 20.853L113.804 20.85ZM61.0958 22.1445C60.3068 22.3695 37.8383 22.482 37.8383 22.482C37.8383 22.482 37.5188 21.888 38.0078 20.736C38.2433 20.181 38.8763 19.7805 39.5243 19.5045C40.3478 19.1535 41.2403 18.99 42.1358 18.99H61.6508L61.6013 21.636C61.6013 21.636 61.8833 21.918 61.0943 22.143L61.0958 22.1445ZM74.5823 33.717H71.0633L69.9368 32.7315V30.4785H72.0203V32.478H74.5823V33.717Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3322 20.7375L73.4007 22.1445H61.0962V22.9335V26.538",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0962 22.9335H117.154",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3069 24.1304L65.8829 25.5659L69.3884 24.1304H62.3069Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3323 24.1304L77.9083 25.5659L81.4138 24.1304H74.3323Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3577 24.1305L89.9322 25.566L93.4377 24.1305H86.3577Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3811 24.1304L101.957 25.5659L105.463 24.1304H98.3811Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.562 25.566L95.986 24.1305L92.4805 25.566H99.562Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5368 25.5659L83.9608 24.1304L80.4553 25.5659H87.5368Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5114 25.5659L71.9354 24.1304L68.4299 25.5659H75.5114Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1272 12.684V15.669",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4036 12.981V15.669",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.219 12.981V15.5145",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6975 15.669V12.981",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3069 12.684V14.754H64.3619V12.6285",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7366 26.559V22.9335H31.5461",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0776 26.2559L39.7541 25.2419H58.7306V26.6564",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9368 27.2265V29.2245H71.9708V26.718",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9544 20.9609C71.3578 20.9609 71.6849 20.6339 71.6849 20.2304C71.6849 19.827 71.3578 19.4999 70.9544 19.4999C70.5509 19.4999 70.2239 19.827 70.2239 20.2304C70.2239 20.6339 70.5509 20.9609 70.9544 20.9609Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8717 36.1484C78.3513 36.1484 78.7402 35.7596 78.7402 35.2799C78.7402 34.8003 78.3513 34.4114 77.8717 34.4114C77.392 34.4114 77.0032 34.8003 77.0032 35.2799C77.0032 35.7596 77.392 36.1484 77.8717 36.1484Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.583 26.8755H117.52",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M115.908 21.168V37.1235",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2551 26.622H30.3926",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 23.637V24.8475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4954 23.637V24.8475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7366 23.8905H60.8141",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6506 18.9915H65.8461V19.7805H64.6431V20.961H61.6506",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9446 12.6285V15.5145",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5198 12.684V16.5705",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8225 32.0985V30.4785H77.511V33.069H74.583",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03833 25.2526V23.1586H31.4198C31.4198 23.1586 34.0103 18.2026 38.4023 17.4706C42.7943 16.7386 45.2723 16.8511 45.2723 16.8511L58.2233 16.8451V15.6691H50.5643V12.3466H55.9703L58.7303 12.7411L59.5193 12.6841V11.5576H61.8278V12.5146H64.8128L66.5018 12.7396L71.0063 12.7966L72.5273 13.6411V15.0496L71.3453 15.7816H66.3893V16.8511H72.3023C72.3023 16.8511 73.9913 20.7931 74.9483 21.4126L87.9563 21.5821L89.7023 20.0056L105.976 19.9486L106.82 20.9056L113.803 20.8486L117.52 21.4111V37.4041H113.408L109.861 39.5446L109.691 40.4461L109.016 41.0086H94.8818L94.0928 40.2196L93.1913 40.2766L89.1938 36.2791V30.8731L88.1798 29.5216L86.0963 29.4646L84.5198 30.9286H81.0848L79.8458 32.8426L83.1683 41.6266C83.1683 41.6266 78.2693 43.4281 78.2123 43.2031C78.1553 42.9781 74.7773 34.9816 74.7773 34.9816L70.2728 34.9246L68.6963 33.5731L68.5838 30.8131L62.3888 30.7006L62.2763 31.4326L54.8438 35.0926C54.8438 35.0926 42.3428 34.9231 39.4703 34.5856C36.5978 34.2481 32.9948 33.4036 32.9948 33.4036L31.9808 34.5856C31.9808 34.5856 31.0238 33.0646 30.5723 32.5021C30.1223 31.9396 29.3333 31.3201 29.3333 31.3201L29.2208 30.2506L30.0098 27.9421H18.4118L18.3278 26.6191H22.2563V25.3096L3.03983 25.2496L3.03833 25.2526Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.011 27.945C30.011 27.945 31.025 24.3975 31.4195 23.1585",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.838 22.4836C37.838 22.4836 60.3065 22.3711 61.0955 22.1461C61.8845 21.9211 61.6025 21.6391 61.6025 21.6391L61.652 18.9931H42.137C41.2415 18.9931 40.349 19.1566 39.5255 19.5076C38.879 19.7836 38.2445 20.1826 38.009 20.7391C37.5215 21.8896 37.8395 22.4851 37.8395 22.4851L37.838 22.4836Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.011 31.911L32.5445 26.538C32.5445 26.538 36.2045 27.3465 38.57 27.393C40.9355 27.4395 55.97 27.552 58.223 27.9465C60.476 28.341 60.968 28.4205 61.6505 29.2245C62.333 30.03 62.39 30.705 62.39 30.705",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9368 30.4786V32.7316L71.0633 33.7171H74.5823V32.0986H72.0203V30.4786H69.9368Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0518 26.5381L105.583 26.8756L108.059 27.6631L108.398 30.8176H113.747V37.4056",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.398 30.8176L104.963 38.1376L103.779 38.9266H94.9955L94.094 40.2211",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.673 34.4911H109.805V39.0946V30.8176",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2229 16.845H66.3889",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattleRifleVariant);
export default __webpack_public_path__ + "static/media/Battle Rifle Variant.28fe3ed85d4e649db30f245f4f48d9ea.svg";
export { ForwardRef as ReactComponent };